import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';
import { Interval } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/Interval';
import { KalenderArbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/kalenderByArbeitsbereiche/KalenderArbeitsbereich';

export class KalenderByMitarbeiterStation extends Interval {
  constructor({
    station,
    arbeitsbereich,
  }: {
    arbeitsbereich: KalenderArbeitsbereich;
    station: ArbeitsbereichStation;
  }) {
    super({ von: station.von, bis: station.bis });
    this.arbeitsbereich = arbeitsbereich;
    this.station = station;
  }

  arbeitsbereich: KalenderArbeitsbereich;
  station: ArbeitsbereichStation;
}
